import { useState } from 'react';
import { Wine } from 'lucide-react';

const IMGBB_API_KEY = 'f6935b01a235980fdffacf05baca1614';

export default function ImageUpload({ currentUrl, onUploaded, size = 80, shape = 'circle', label = 'Byt bild', showCamera = false }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  async function handleFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      setError('Endast bilder är tillåtna.');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      setError('Bilden får max vara 10 MB.');
      return;
    }

    setUploading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('image', file);

      const res = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();

      if (!data.success) {
        throw new Error(data.error?.message || 'Upload failed');
      }

      onUploaded(data.data.url);
    } catch (err) {
      setError('Uppladdningen misslyckades. Försök igen.');
      console.error('Upload error:', err);
    }
    setUploading(false);
  }

  const isCircle = shape === 'circle';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
      <div style={{
        width: size, height: size,
        borderRadius: isCircle ? '50%' : 8,
        background: 'var(--wine-light)',
        overflow: 'hidden',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        border: '2px solid var(--border)',
        flexShrink: 0,
      }}>
        {currentUrl ? (
          <img src={currentUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <Wine size={size * 0.35} color="var(--wine)" strokeWidth={1.5} />
        )}
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 12 }}>
        <label style={{
          fontSize: 12, color: 'var(--teal)', cursor: 'pointer',
          fontWeight: 500, textDecoration: 'underline',
          opacity: uploading ? 0.5 : 1,
        }}>
          {uploading ? 'Laddar upp...' : label}
          <input
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFile}
            disabled={uploading}
          />
        </label>

        {showCamera && (
          <label style={{
            fontSize: 12, color: 'var(--teal)', cursor: 'pointer',
            fontWeight: 500, textDecoration: 'underline',
            opacity: uploading ? 0.5 : 1,
          }}>
            {uploading ? 'Laddar upp...' : 'Ta foto'}
            <input
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: 'none' }}
              onChange={handleFile}
              disabled={uploading}
            />
          </label>
        )}
      </div>

      {error && <div style={{ fontSize: 11, color: '#a32d2d' }}>{error}</div>}
    </div>
  );
}
